import * as React from 'react';
import { cn } from '../lib/cn';

/**
 * Eyebrow — small uppercase label that introduces a section.
 * Used heavily on the marketing site ("BUILT FOR PODIATRISTS").
 */

export interface EyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: 'brand' | 'muted' | 'clay';
}

const toneClasses = {
  brand: 'text-brand-500',
  muted: 'text-text-muted',
  clay: 'text-clay-500',
};

export function Eyebrow({ tone = 'brand', className, ...props }: EyebrowProps) {
  return (
    <span
      className={cn(
        'inline-block text-xs font-medium uppercase tracking-eyebrow',
        toneClasses[tone],
        className,
      )}
      {...props}
    />
  );
}
